import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { useLanguage } from '../lib/LanguageContext';
import { translations } from '../lib/translations';
export function ShiftSection() {
  const ref = useRef<HTMLElement>(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const {
    lang
  } = useLanguage();
  const t = translations[lang].shift;
  return <section ref={ref} style={{
    backgroundColor: '#f0f0f0',
    padding: '10rem 0',
    position: 'relative',
    overflow: 'hidden'
  }} data-id="element-71">
      <div style={{
      maxWidth: '48rem',
      margin: '0 auto',
      padding: '0 2rem',
      position: 'relative'
    }} data-id="element-72">
        {/* Section label */}
        <motion.p initial={{
        opacity: 0
      }} animate={isInView ? {
        opacity: 1
      } : {
        opacity: 0
      }} transition={{
        duration: 0.6
      }} style={{
        fontFamily: '"IBM Plex Mono", monospace',
        fontSize: '0.75rem',
        letterSpacing: '0.3em',
        textTransform: 'uppercase',
        color: 'var(--grey-500)',
        marginBottom: '4rem',
        position: 'relative',
        zIndex: 1
      }} data-id="element-73">
          {t.label}
        </motion.p>

        {/* Decorative large year */}
        <motion.div initial={{
        opacity: 0
      }} animate={isInView ? {
        opacity: 1
      } : {
        opacity: 0
      }} transition={{
        duration: 1,
        delay: 0.2
      }} style={{
        position: 'absolute',
        top: '4rem',
        right: '-2rem',
        fontFamily: '"IBM Plex Sans", sans-serif',
        fontWeight: 900,
        fontSize: 'clamp(100px, 18vw, 200px)',
        color: '#e0e0e0',
        lineHeight: 1,
        userSelect: 'none',
        pointerEvents: 'none',
        zIndex: 0
      }} data-id="element-74">
          1987
        </motion.div>

        {/* Title */}
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.7,
        delay: 0.15
      }} style={{
        fontFamily: '"IBM Plex Sans", sans-serif',
        fontWeight: 900,
        fontSize: 'clamp(2.5rem, 5vw, 3.75rem)',
        lineHeight: 1.1,
        color: 'var(--black)',
        marginBottom: '4rem',
        position: 'relative',
        zIndex: 1
      }} data-id="element-75">
          {t.title}
        </motion.h2>

        {/* Body */}
        <div style={{
        position: 'relative',
        zIndex: 1
      }} data-id="element-76">
          <motion.p initial={{
          opacity: 0,
          y: 16
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 16
        }} transition={{
          duration: 0.7,
          delay: 0.25
        }} style={{
          fontFamily: '"IBM Plex Sans", sans-serif',
          fontWeight: 300,
          fontSize: 'clamp(1rem, 2vw, 1.25rem)',
          color: 'var(--grey-700)',
          lineHeight: 1.8,
          marginBottom: '1.5rem'
        }} data-id="element-77">
            {t.p1}
          </motion.p>

          <motion.p initial={{
          opacity: 0,
          y: 16
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 16
        }} transition={{
          duration: 0.7,
          delay: 0.35
        }} style={{
          fontFamily: '"IBM Plex Sans", sans-serif',
          fontWeight: 300,
          fontSize: 'clamp(1rem, 2vw, 1.25rem)',
          color: 'var(--grey-700)',
          lineHeight: 1.8,
          marginBottom: '2rem'
        }} data-id="element-78">
            {t.p2}
          </motion.p>

          {/* Emphasis quote */}
          <motion.blockquote initial={{
          opacity: 0,
          x: -20
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {
          opacity: 0,
          x: -20
        }} transition={{
          duration: 0.8,
          delay: 0.45
        }} style={{
          fontFamily: '"IBM Plex Sans", sans-serif',
          fontWeight: 700,
          fontSize: 'clamp(1.2rem, 2.5vw, 1.5rem)',
          color: 'var(--black)',
          borderLeft: '2px solid var(--red)',
          paddingLeft: '1.5rem',
          margin: '2rem 0',
          lineHeight: 1.5
        }} data-id="element-79">
            {t.quote}
          </motion.blockquote>

          {/* Final answer */}
          <motion.p initial={{
          opacity: 0,
          y: 16
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 16
        }} transition={{
          duration: 0.7,
          delay: 0.55
        }} style={{
          fontFamily: '"IBM Plex Sans", sans-serif',
          fontWeight: 900,
          fontSize: 'clamp(1.5rem, 3vw, 2rem)',
          color: 'var(--black)',
          marginTop: '3rem'
        }} data-id="element-80">
            {t.answer}
          </motion.p>
        </div>
      </div>
    </section>;
}